import axios from 'axios'


/* SYC : GA 태그 API 호출 
*  Request Type     : Int 
*  Request prameter : 상품 ID
*  Return Type      : Json Object
*  Return prameter  : Real Category
*  Description      : 리얼 카테고리 호출
*/
export async function googleTagApi(item_id) {
  const url = `${process.env.REACT_APP_API_URL}/front/v3/ad/gaua4tag/?item_id=${item_id}`

  try {
    const result = await axios.get(url);
    return result;

  } catch (error) {
    console.log(error);
  }
}


// WEBPACK FOOTER //
// ./src/estimate_list/components/api/googleTag.js